import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase.js';
import { lastNDates } from '../../lib/dates.js';

export default function RecentWins() {
  const [wins, setWins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const since = lastNDates(7).slice(-1)[0];

    async function load() {
      const { data } = await supabase
        .from('daily_wins')
        .select('id, date, win')
        .gte('date', since)
        .order('date', { ascending: false });
      if (!mounted) return;
      setWins(data ?? []);
      setLoading(false);
    }
    load();

    const channel = supabase
      .channel('daily-wins-changes')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'daily_wins' },
        () => load()
      )
      .subscribe();

    return () => {
      mounted = false;
      supabase.removeChannel(channel);
    };
  }, []);

  return (
    <div className="bg-bg-card border border-border-base rounded p-5">
      <h3 className="text-xs uppercase tracking-wider text-text-secondary mb-3">
        🏆 Recent Wins
      </h3>
      {loading ? (
        <div className="text-sm text-text-muted text-center py-3">Loading…</div>
      ) : wins.length === 0 ? (
        <div className="text-sm text-text-muted text-center py-3">
          No wins logged in the last 7 days.
          <div className="text-xs text-text-muted mt-1">
            Check-out adds these (Phase 5).
          </div>
        </div>
      ) : (
        <ul className="space-y-2">
          {wins.map((w) => (
            <li key={w.id} className="text-sm">
              <div className="text-text-primary">{w.win}</div>
              <div className="text-[10px] uppercase tracking-wide text-text-muted mt-0.5">
                {formatRelativeDate(w.date)}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function formatRelativeDate(d) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const winDate = new Date(d);
  winDate.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today - winDate) / 86400000);
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;
  return winDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
